import { THEME_TYPES } from '@infoods/lifebase-ui';
import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';

export const challengesModule = angular
  .module('app.challenges', [])
  .config(challengesConfig);

challengesConfig.$inject = ['$routeProvider'];

function challengesConfig($routeProvider) {
  $routeProvider
    .when('/challenges-list', {
      template: '<ngz-challenges-list></ngz-challenges-list>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/challenge-create', {
      template: '<ngz-challenge-create></ngz-challenge-create>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/challenge-preview/:challengeId', {
      template: '<ngz-challenge-preview></ngz-challenge-preview>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
      },
    })
    .when('/challenge-profile/:challengeId', {
      reloadOnSearch: false,
      template: '<ngz-challenge-profile></ngz-challenge-profile>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/challenge-landing/:challengeId', {
      template: '<ngz-challenge-landing></ngz-challenge-landing>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
      },
    })
    .when('/challenge-leaderboard/:challengeId', {
      template: '<ngz-challenge-leaderboard></ngz-challenge-leaderboard>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
      },
    })
    .when('/challenge-sign-up/:challengeId', {
      template: '<ngz-challenge-sign-up></ngz-challenge-sign-up>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
      },
    })
    .when('/nutrition-account-not-found', {
      template: '<ngz-nutrition-account-not-found></ngz-nutrition-account-not-found>',
      pageConfig: {
        theme: THEME_TYPES.NUTRITION,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/already-participant', {
      template: '<ngz-already-participant></ngz-already-participant>',
      pageConfig: {
        hideHeader: true,
        hideFooter: true,
      },
    })
  }